<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">list</v-icon> Mes bulletins d'adhésion
            </span>
        </div>

        <div class="container align-items-center justify-content-center">
            <v-card class="p-4">
                <div class="mb-5">
                    <v-dialog v-model="createModale" persistent max-width="600px">
                        <template v-slot:activator="{ on }">
                            <v-btn outlined class="custom-button-primary" v-on="on" @click="createModale = true">
                                <v-icon left>add</v-icon>
                                Créer un Bulletin d'adhésion
                            </v-btn>
                        </template>
                        <v-card>
                        </v-card>
                    </v-dialog>
                </div>

                <div v-if="cadhConfigs.length">
                    <v-data-table :headers="headers" :items="cadhConfigs" :loading="$global.loading"
                                  class="border" :footer-props="{
                                itemsPerPageAllText: 'Toutes',
                                itemsPerPageText: 'Configurations par page',
                                itemsPerPageOptions: [10, 20, 50, 100]
                            }">
                        <template v-slot:item.name="{ item }">
                            <div>
                                <router-link :to="'/configuration/adhesion-management/edit/' + encodeUri(item.id)"
                                             v-if="item.name !== null">
                                    {{item.name}}
                                </router-link>

                                <router-link :to="'/configuration/adhesion-management/edit/' + encodeUri(item.id)"
                                             v-else>-</router-link>
                            </div>
                        </template>

                        <template v-slot:item.configurationDate="{ item }">
                            <div>
                                {{ formatDate(item.configurationDate, false) }}
                            </div>
                        </template>

                        <template v-slot:item.actions="{ on, item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" color="primary" class="custom-button-error mr-2"
                                           @click="seeConfig(item)">
                                        <v-icon>remove_red_eye</v-icon>
                                    </v-btn>
                                </template>
                                <span>Prévisualiser</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" @click="prepareDuplication(item)" class="mr-2">
                                        <v-icon>content_copy</v-icon>
                                    </v-btn>
                                </template>
                                <span>Dupliquer</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small icon v-on="on" class="custom-button-error" @click="deleteConfig(item)">
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                </template>
                                <span>Supprimer</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </div>

                <div v-else class="text-center">
                    <small>Vous n'avez aucun bulletin pour le moment</small>
                </div>
            </v-card>
        </div>

        <v-dialog v-model="noDeleteDialog" max-width="400" style="{ 'zIndex': 200 }" @keydown.esc="cancel">
            <v-card>
                <v-toolbar dark class="bg-error" dense flat>
                    <v-toolbar-title class="white--text">Attention</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="pa-4">
                    <div>Vous ne pouvez pas supprimer ce bulletin d'adhésion car des campagnes y sont associées.</div>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="noDeleteDialog = false">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="copyModale" max-width="400" style="{ 'zIndex': 200 }" @keydown.esc="cancel">
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title>Duplication d'un bulletin d'adhésion</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="pa-4">
                    <v-text-field
                      outlined
                      label="Nom du bulletin"
                      v-model="duplicatedName"
                      hide-details
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="copyModale = false">
                        Annuler
                    </v-btn>
                    <v-btn class="default-button" @click="duplicateConfig()">
                        Dupliquer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="createModale" max-width="400" style="{ 'zIndex': 200 }" @keydown.esc="createModale = false">
            <v-card>
                <v-toolbar dense flat>
                    <v-toolbar-title>Création d'un bulletin d'adhésion</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="pa-4">
                    <v-text-field
                      outlined
                      label="Nom du bulletin"
                      v-model="newConfigName"
                      hide-details
                    ></v-text-field>
                </v-card-text>

                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn @click="createModale = false">
                        Annuler
                    </v-btn>
                    <v-btn class="default-button" @click="createConfig()">
                        Créer
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapState } from "vuex"
import _ from "lodash"
import Confirm from "@/components/tools/Confirm.vue"

export default {
    name: "CadhManagement",
    components: { Confirm },
    data() {
        return {
            cadhConfigs: [],
            noDeleteDialog: false,
            copyModale: false,
            createModale: false,
            duplicatedId: null,
            duplicatedName: null,
            newConfigName: null,
            headers: [
                {
                    text: "Nom",
                    value: "name",
                },
                {
                    text: "Campagnes associées",
                    value: "campaignsCount",
                    align: "center",
                },
                {
                    text: "Date de création",
                    value: "configurationDate",
                },
                {
                    text: "Statut de configuration",
                    value: "configured",
                },
                {
                    text: "Actions",
                    value: "actions",
                    sortable: false,
                },
            ],
        }
    },
    methods: {
        getConfigs: _.debounce(function() {
            this.$http.get("adhesion/configs/" + this.account.id).then(res => {
                this.cadhConfigs = res.body.data.cadhConfigurations
            })
        }),
        deleteConfig(config) {
            if (config.campaignsCount === 0) {
                this.$refs.confirm.open("Attention", "Voulez-vous vraiment supprimer ce bulletin d'adhésion ?",
                  { color: "red" }).then((confirm) => {
                    if (confirm) {
                        this.$global.loading = true

                        this.$http.delete("adhesion/configs/delete/" + config.id).then(() => {
                            this.$global.loading = false
                            this.getConfigs()
                        })
                    }
                })
            } else {
                this.noDeleteDialog = true
            }
        },
        seeConfig(config) {
            let url = window.location.origin + "/cadh-preview/" + config.token

            window.open(url)
        },
        duplicateConfig() {
            let payload = {
                id: this.duplicatedId,
                name: this.duplicatedName,
            }

            this.$global.loading = true

            this.$http.post("adhesion/configs/duplicate", payload).then(res => {
                this.copyModale = false
                this.$global.loading = false
                this.getConfigs()
            })
        },
        prepareDuplication(config) {
            this.duplicatedId = config.id
            this.duplicatedName = config.name

            this.copyModale = true
        },
        createConfig() {
            let payload = {
                accountId: this.account.id,
                name: this.newConfigName
            }

            this.$http.post("adhesion/configs/create", payload).then(res => {
                this.createModale = false
                this.$global.loading = false
                let newId = res.body.data.cadhConfigurationId

                this.$router.push('/configuration/adhesion-management/edit/' + this.encodeUri(newId))
            })
        },
        cancel() {
            this.resolve(false)
            this.noDeleteDialog = false
        },
        encodeUri(id) {
            return btoa(id)
        },
    },
    computed: {
        ...mapState("account", ["account"]),
    },
    created() {
        this.getConfigs()
    },
}
</script>